/* ============================================================
   I KNOW YOU — interactions & animations
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Page loader ---------- */
  window.addEventListener('load', function () {
    setTimeout(function () { document.body.classList.add('loaded'); }, reduce ? 0 : 1100);
  });

  /* ---------- Hero: split title into chars ---------- */
  function splitHero() {
    var title = document.querySelector('[data-split]');
    if (!title || title.dataset.done) return;
    title.dataset.done = '1';
    var text = title.textContent.trim();
    title.setAttribute('aria-label', text);
    title.textContent = '';
    text.split('').forEach(function (ch, i) {
      var span = document.createElement('span');
      span.className = 'char';
      span.setAttribute('aria-hidden', 'true');
      span.style.animationDelay = (0.5 + i * 0.045) + 's';
      span.textContent = ch === ' ' ? ' ' : ch;
      title.appendChild(span);
    });
    var hero = title.closest('.hero');
    if (hero) requestAnimationFrame(function () { hero.classList.add('is-in'); });
  }
  splitHero();

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal, .reveal-img');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el, i) {
      var parent = el.closest('[data-stagger]');
      if (parent) el.style.setProperty('--i', Array.prototype.indexOf.call(parent.children, el));
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Manifesto word-by-word lighting ---------- */
  document.querySelectorAll('[data-manifesto]').forEach(function (m) {
    var text = m.textContent.trim();
    m.textContent = '';
    text.split(' ').forEach(function (w) {
      var s = document.createElement('span');
      s.className = 'word'; s.textContent = w + ' ';
      m.appendChild(s);
    });
    if (reduce) { m.classList.add('is-lit'); return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en, obs) {
        en.forEach(function (e) { if (e.isIntersecting) { m.classList.add('is-lit'); obs.disconnect(); } });
      }, { threshold: 0.5 }).observe(m);
    } else { m.classList.add('is-lit'); }
  });

  /* ---------- Header hide on scroll down ---------- */
  var header = document.querySelector('.header');
  var lastY = 0;
  window.addEventListener('scroll', function () {
    var y = window.pageYOffset;
    if (header) {
      if (y > lastY && y > 200) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
    }
    lastY = y;
  }, { passive: true });

  /* ---------- Custom cursor ---------- */
  var cursor = document.getElementById('Cursor');
  if (cursor && window.matchMedia('(hover: hover)').matches && !reduce) {
    var dot = cursor.querySelector('.cursor__dot');
    var ring = cursor.querySelector('.cursor__ring');
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
    });
    (function loop() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
    var hoverTargets = 'a, button, [data-cursor]';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest(hoverTargets)) cursor.classList.add('is-hover');
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest(hoverTargets)) cursor.classList.remove('is-hover');
    });
  }

  /* ---------- Mobile nav toggle ---------- */
  var toggle = document.querySelector('.nav-toggle');
  if (toggle) toggle.addEventListener('click', function () {
    document.body.classList.toggle('nav-open');
  });

  /* ---------- Marquee: duplicate track for seamless loop ---------- */
  document.querySelectorAll('.marquee__track').forEach(function (t) {
    t.innerHTML += t.innerHTML;
  });
})();
